import { WidgetType } from "@uiw/react-codemirror";
import { createImageControls, createImageResize } from "@/04-features/edit-image";
export class MarkdownImageWidget extends WidgetType {
    constructor(config) {
        super();
        this.config = config;
        this.destroyInteractions = null;
    }
    toDOM(view) {
        const container = document.createElement("span");
        const frame = document.createElement("span");
        const image = this.createImage();
        container.className = "cm-markdown-image-widget";
        frame.className = "cm-markdown-image-frame";
        frame.append(image);
        container.append(frame);
        this.updateImage(frame, image);
        this.bindInteractions(view, container, frame, image);
        return container;
    }
    updateDOM(container, view, previousWidget) {
        var _a, _b, _c;
        const frame = container.querySelector(".cm-markdown-image-frame");
        const image = frame === null || frame === void 0 ? void 0 : frame.querySelector(".cm-markdown-image");
        if (!frame || !image)
            return false;
        (_a = previousWidget.destroyInteractions) === null || _a === void 0 ? void 0 : _a.call(previousWidget);
        previousWidget.destroyInteractions = null;
        (_b = frame.querySelector(".cm-markdown-image-resize-handle")) === null || _b === void 0 ? void 0 : _b.remove();
        (_c = frame.querySelector(".cm-markdown-image-controls")) === null || _c === void 0 ? void 0 : _c.remove();
        this.updateImage(frame, image);
        this.bindInteractions(view, container, frame, image);
        return true;
    }
    ignoreEvent() {
        return true;
    }
    destroy() {
        var _a;
        (_a = this.destroyInteractions) === null || _a === void 0 ? void 0 : _a.call(this);
        this.destroyInteractions = null;
    }
    bindInteractions(view, container, frame, image) {
        const resizeHandle = this.createResizeHandle();
        const { controls } = createImageControls({
            onSource: () => this.showSource(view)
        });
        frame.append(resizeHandle, controls);
        const resize = createImageResize({
            view,
            container,
            frame,
            image,
            handle: resizeHandle,
            controls,
            imageTo: this.config.imageTo,
            decorationTo: this.config.decorationTo,
            initialWidth: this.config.width
        });
        const activateResize = (event) => {
            event.preventDefault();
            event.stopPropagation();
            resize.activate();
        };
        const showSource = (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.showSource(view);
        };
        image.addEventListener("click", activateResize);
        image.addEventListener("dblclick", showSource);
        this.destroyInteractions = () => {
            image.removeEventListener("click", activateResize);
            image.removeEventListener("dblclick", showSource);
            resize.destroy();
        };
    }
    createImage() {
        const image = document.createElement("img");
        image.className = "cm-markdown-image";
        image.src = this.config.source;
        image.alt = this.config.alt;
        image.loading = "lazy";
        if (this.config.title)
            image.title = this.config.title;
        return image;
    }
    updateImage(frame, image) {
        if (image.getAttribute("src") !== this.config.source) {
            image.src = this.config.source;
        }
        image.alt = this.config.alt;
        if (this.config.title) {
            image.title = this.config.title;
        }
        else {
            image.removeAttribute("title");
        }
        if (this.config.width === null) {
            frame.style.removeProperty("width");
            image.style.removeProperty("width");
        }
        else {
            frame.style.width = `${this.config.width}%`;
            image.style.width = "100%";
        }
    }
    createResizeHandle() {
        const handle = document.createElement("button");
        handle.className = "cm-markdown-image-resize-handle";
        handle.type = "button";
        handle.title = "Resize image";
        handle.setAttribute("aria-label", "Resize image");
        handle.hidden = true;
        return handle;
    }
    showSource(view) {
        view.dispatch({
            selection: {
                anchor: this.config.imageFrom,
                head: this.config.decorationTo
            },
            scrollIntoView: true
        });
        view.focus();
    }
}
